"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayHtVoiceIdEnum = void 0;
exports.PlayHtVoiceIdEnum = {
    Jennifer: "jennifer",
    Melissa: "melissa",
    Will: "will",
    Chris: "chris",
    Matt: "matt",
    Jack: "jack",
    Ruby: "ruby",
    Davis: "davis",
    Donna: "donna",
    Michael: "michael",
};
